import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/lib/api';
import { Card, ErrorText } from '@/components/ui';
import { formatDateTime } from '@/lib/dates';

export function AdminAuditPage() {
  const api = useApi();
  const logs = useQuery({ queryKey: ['admin', 'audit'], queryFn: api.admin.auditLogs });
  if (logs.isError) return <ErrorText error={logs.error} />;
  return (
    <Card>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-muted-foreground">
            <tr>
              <th className="py-2 pr-4 font-medium">When</th>
              <th className="py-2 pr-4 font-medium">Who</th>
              <th className="py-2 pr-4 font-medium">Action</th>
              <th className="py-2 pr-4 font-medium">Organization</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {logs.data?.logs.map(({ log, actorEmail, orgName }) => (
              <tr key={log.id}>
                <td className="whitespace-nowrap py-2 pr-4 text-muted-foreground">
                  {formatDateTime(log.createdAt)}
                </td>
                <td className="py-2 pr-4">{actorEmail ?? 'system'}</td>
                <td className="py-2 pr-4 font-mono text-xs">{log.action}</td>
                <td className="py-2 pr-4">{orgName ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
